import { QuotasRequestOptions } from 'features/hubspot/types'
import { EventMetricQuota } from 'features/metrics/types'

export interface QuotaState {
  current?: number
  limit?: number
  soft?: boolean
  period?: string
  quotasRequestType?: QuotasRequestOptions
  eventMetricQuotaType?: EventMetricQuota
}

export interface QuotaResult extends Partial<QuotaState> {
  type: QuotaTypes
  exceeded: boolean
  hit: boolean
}

export enum QuotaTypes {
  Maps = 'mapsQuota',
  Workflows = 'workflowsQuota',
  MapsPublic = 'mapsPublic',
  MapLoads = 'mapLoadsQuota',
  Geocoding = 'geocodingQuota',
  Isolines = 'isolinesQuota',
  Apps = 'appsQuota',
  Editors = 'editors',
  Viewers = 'viewers',
  Tokens = 'tokensQuota',
  Usage = 'usageQuota',
  Lds = 'ldsQuota',
  Basemaps = 'basemapsQuota'
}
